import {InventoryEntityModel} from "../../inventory-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {ChangeDetectorRef, Component, OnDestroy, ViewChild} from "@angular/core";
import {SupplierSearchPageComponent} from "../../../supplier/supplier-search-page/supplier-search-page.component";
import {SupplierEditPageComponent} from "../../../supplier/supplier-edit-page/supplier-edit-page.component";
import {SuppliedInventoryData} from "../../inventory.data";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";
import {Subscription} from "rxjs";
import {EditGridComponent} from "../../../../framework/entity/edit/edit-grid/edit-grid.component";
import {MeasureEditPageComponent} from "../../../measure/measure-edit-page/measure-edit-page.component";

@Component({
    selector: "wbo-inventory-edit-details",
    templateUrl: "./inventory-edit-details.component.html"
})

export class InventoryEditDetailsComponent implements OnDestroy {
    EditMode = EditMode;
    SupplierSearchPageComponent = SupplierSearchPageComponent;
    SupplierEditPageComponent = SupplierEditPageComponent;

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: InventoryEntityModel, public editService: EditService, private changeDetectionRef: ChangeDetectorRef) {
        // when cloning it should validate all records
        this.subscriptions.add(this.model.$data.subscribe(() => {
            setTimeout(() => this.editGridComponent.revalidate());
        }));
    }

    preferredSupplierSaved(entity: SuppliedInventoryData): void {
        const data: SuppliedInventoryData = entity;
        if (entity.preferredSupplier) {
            this.model.data.preferredSupplier.vendorId = data.vendor.vendorId;

            const supplierArr: Array<any> = this.model.data.suppliedInventories;
            for (let i = 0; i < supplierArr.length; i++) {
                if (data.vendor.vendorId != supplierArr[i].vendor.vendorId) {
                    supplierArr[i].preferredSupplier = false;
                }
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get restrictedBaseMeasureIdParams(): any {
        return {
            [MeasureEditPageComponent.RESTRICTED_BASE_MEASURE_ID]: this.model.data.standardStockSize.measure.base ?
                this.model.data.standardStockSize.measure.measureId :
                this.model.data.standardStockSize.measure.baseConversion.convertTo.measureId
        };
    }
}
